module.exports = __webpack_public_path__ + "static/media/etapa4.9eb3671a.svg";